import { Dispatch, FC, SetStateAction, useState } from 'react';

import { message } from 'antd';
import { UploadChangeParam } from 'antd/es/upload';
import { UploadFile, UploadProps } from 'antd/lib';

import {
  ColSize,
  DraggerUploadFile,
  RowSize,
} from '../../../../../../../../../../../shared/components';
import { Modal } from '@hdi-seguros/web-components.modal';
import { ActionButton } from '@hdi-seguros/web-components.action-button';

interface UploadFileModalProps {
  canShowUploadModalUploadFile: boolean;
  setCanShowUploadModalUploadFile: Dispatch<SetStateAction<boolean>>;
  setFileSelect: Dispatch<SetStateAction<any[]>>;
}

export const UploadFileModal: FC<UploadFileModalProps> = ({
  canShowUploadModalUploadFile,
  setCanShowUploadModalUploadFile,
  setFileSelect,
}) => {
  const [fileSelectUpload, setFileSelectUpload] = useState<any[]>([]);

  const openFile = (file: any) => {
    let messageError: string =
      'No hay archivo seleccionado o el archivo está vacío.';

    if (file.base) {
      const newWindow = window.open();

      if (newWindow) {
        const document: string = `<iframe src="${file.base}" style="width:100%; height:100%;"></iframe>`;
        newWindow.document.write(document);
        return;
      }

      messageError =
        'La ventana emergente no se pudo abrir. Asegúrate de que las ventanas emergentes no estén bloqueadas en tu navegador.';
    }

    message.error(messageError);
  };

  const fileToBase64 = (file: Blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (event) => {
        const errorMessage = `Error al cargar el archivo: ${event?.target?.error?.message}`;
        reject(new Error(errorMessage));
      };
    });
  };
  const handleFileSelection = async (
    info: UploadChangeParam<UploadFile<any>>
  ) => {
    const maxFileSize = 2 * 1024 * 1024;

    if (info.file.status === 'removed') {
      const updatedFiles = fileSelectUpload?.filter(
        (file: { uid: string }) => file.uid !== info.file.uid
      );
      setFileSelectUpload(updatedFiles);
      return;
    }

    const files = await Promise.all(
      info.fileList.map(async (file) => {
        if (file.originFileObj instanceof Blob) {
          if (file.originFileObj.size > maxFileSize) {
            message.error(
              `El archivo ${file.name} supera el tamaño máximo de 2MB`
            );

            return null;
          }

          const base64 = await fileToBase64(file.originFileObj);
          return {
            uid: file.uid,
            name: file.name,
            mediaType: file.type,
            base: base64,
          };
        }
        return file;
      })
    );

    setFileSelectUpload(files.filter((file) => file !== null));
  };

  const handleFileDrop = async (event: React.DragEvent<HTMLDivElement>) => {
    const files = Array.from(event.dataTransfer.files);

    try {
      const fileList = await Promise.all(
        files.map(async (file) => {
          const base64 = await fileToBase64(file);
          return {
            name: file.name,
            mediaType: file.type,
            base: base64,
          };
        })
      );

      setFileSelectUpload((prevFiles: any) => [...prevFiles, ...fileList]);
    } catch (error) {
      message.error('Error al cargar los archivos');
    }
  };

  const draggerProps: UploadProps = {
    name: 'file',
    multiple: true,
    customRequest: () => false,
    onChange: (info) => {
      handleFileSelection(info);
    },
    onDrop: (e) => {
      handleFileDrop(e);
    },
  };

  const handleConfirm = () => {
    setCanShowUploadModalUploadFile(false);
    setFileSelect((prevFiles: any) => [...prevFiles, ...fileSelectUpload]);
    setFileSelectUpload([]);
  };

  const handleCancel = () => {
    setCanShowUploadModalUploadFile(false);
    setFileSelectUpload([]);
  };

  return (
    <Modal
      centered
      footer={
        <>
          <ActionButton 
            label='Cancelar'
            type="secondary"
            onClick={handleCancel}
          />

          <ActionButton 
            label='Cnnfirmar'
            type="primary"
            onClick={handleConfirm}
            disabled={!fileSelectUpload.length}
          />
        </>
      }
      onCancel={handleCancel}
      open={canShowUploadModalUploadFile}
      title='Cargar archivos'
      width={650}
    >
      <RowSize className='mb-1' rowProps={{ gutter: [0, 0] }}>
        <ColSize size={100}>
          <RowSize rowProps={{ gutter: [0, 0], justify: 'center' }}>
            <DraggerUploadFile
              draggerProps={draggerProps}
              fileList={fileSelectUpload}
              onPreview={(file) => openFile(file)}
              formatFile={'PDF'}
            />
          </RowSize>
        </ColSize>
      </RowSize>
    </Modal>
  );
};
